(function () {
  function initInteriorMaterialsStudio(root) {
    if (!root || root.dataset.imsInitialized === 'true') return;

    root.dataset.imsInitialized = 'true';

    var tabTriggers = Array.prototype.slice.call(root.querySelectorAll('[data-ims-tab-trigger]'));
    var tabPanels = Array.prototype.slice.call(root.querySelectorAll('[data-ims-tab-panel]'));
    var openButton = root.querySelector('[data-ims-open]');
    var modal = root.querySelector('[data-ims-modal]');
    var modalMedia = root.querySelector('[data-ims-modal-media]');

    function activateTab(id) {
      if (!id) return;

      tabTriggers.forEach(function (trigger) {
        var isActive = trigger.getAttribute('data-ims-tab-trigger') === id;

        trigger.classList.toggle('is-active', isActive);
        trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      tabPanels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-ims-tab-panel') === id;

        panel.classList.toggle('is-active', isActive);
      });
    }

    function moveModalToBody() {
      if (!modal) return;

      if (modal.parentNode !== document.body) {
        document.body.appendChild(modal);
      }
    }

    function openModal() {
      if (!modal) return;

      moveModalToBody();

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ims-modal-open');
    }

    function closeModal() {
      if (!modal) return;

      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ims-modal-open');
    }

    tabTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        activateTab(trigger.getAttribute('data-ims-tab-trigger'));
      });
    });

    if (openButton) {
      openButton.addEventListener('click', function (event) {
        event.preventDefault();
        openModal();
      });
    }

    if (modal) {
      modal.addEventListener('click', function (event) {
        if (!modal.classList.contains('is-open')) return;

        var clickedClose = event.target.closest('[data-ims-close]');
        var clickedInsideImage = modalMedia && modalMedia.contains(event.target);

        if (clickedClose || !clickedInsideImage) {
          closeModal();
        }
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal && modal.classList.contains('is-open')) {
        closeModal();
      }
    });

    activateTab('materiales');
  }

  function initAllInteriorMaterialsStudios() {
    var roots = document.querySelectorAll('[data-ims-root]');

    roots.forEach(function (root) {
      initInteriorMaterialsStudio(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllInteriorMaterialsStudios);
  } else {
    initAllInteriorMaterialsStudios();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-ims-root]');

    if (root) {
      root.dataset.imsInitialized = 'false';
      initInteriorMaterialsStudio(root);
    }
  });
})();